var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-modal" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitItemData($event)
          },
        },
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "card-footer justify-content-between align-items-center",
          },
          [
            _c("div", [
              _c("div", { staticClass: "custom-control custom-checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.confirmContract,
                      expression: "confirmContract",
                    },
                  ],
                  staticClass: "custom-control-input",
                  attrs: { id: "confirm", type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.confirmContract)
                      ? _vm._i(_vm.confirmContract, null) > -1
                      : _vm.confirmContract,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.confirmContract,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.confirmContract = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.confirmContract = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.confirmContract = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "custom-control-label",
                    attrs: { for: "confirm" },
                  },
                  [_vm._v("Confirm Contract")]
                ),
              ]),
              _vm._v(" "),
              _vm.$v.confirmContract.$error
                ? _c("div", [
                    !_vm.$v.confirmContract.required
                      ? _c(
                          "span",
                          { staticClass: "form-group__message text-danger" },
                          [_vm._v(_vm._s(_vm.$tc("validation.required")))]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c(
                  "base-button",
                  {
                    staticClass: "mr-3",
                    attrs: { outline: true, color: "theme", type: "button" },
                    on: { click: _vm.closeItemModal },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("general.cancel")) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.isEdit
                  ? _c(
                      "base-button",
                      {
                        attrs: { loading: _vm.isLoading, color: "theme" },
                        on: { click: _vm.submitItemData },
                      },
                      [_vm._v("\n          " + _vm._s(_vm.name) + "\n        ")]
                    )
                  : _c(
                      "base-button",
                      {
                        attrs: {
                          loading: _vm.isLoading,
                          icon: "save",
                          color: "theme",
                          type: "submit",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("general.save")) +
                            "\n        "
                        ),
                      ]
                    ),
              ],
              1
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-body" }, [
      _c("h3", { staticClass: "text-right" }, [_vm._v("APPENDIX - B")]),
      _vm._v(" "),
      _c("h3", { staticClass: "text-center" }, [
        _c("u", [_vm._v("WRITTEN OFFER")]),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text-center" }, [
        _vm._v("(To be obtained on Customer’s company letter head)"),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("span", [_vm._v("September 21, 2022")]),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("span", [_vm._v("To,")]),
        _c("br"),
        _vm._v(" "),
        _c("span", [_vm._v("HabibMetro Islamic Banking")]),
        _c("br"),
        _vm._v(" "),
        _c("span", [_vm._v("Main Branch")]),
        _c("br"),
        _vm._v(" "),
        _c("span", [_vm._v("II Chundrigar Road")]),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("span", [_vm._v("Dear Sirs,")]),
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { width: "80%", margin: "auto" } }, [
        _c("h4", { staticClass: "text-center" }, [
          _c("u", [_vm._v("Written offer for the sale of Goods")]),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-center" }, [
          _vm._v(
            "We (the “Customer”) are pleased to confirm our willingness to sell the following Goods subject to the following terms and conditions:"
          ),
        ]),
        _vm._v(" "),
        _c("ol", { staticClass: "bracketed-list", attrs: { type: "a" } }, [
          _c("li", [
            _vm._v("Description of the Goods:\n            "),
            _c("input", {
              staticClass: "form-control",
              attrs: { type: "text", id: "content1" },
            }),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("Quantity of Goods:\n            "),
            _c("input", {
              staticClass: "form-control",
              attrs: { type: "text", id: "content2" },
            }),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("Specification of Goods:\n            "),
            _c("input", {
              staticClass: "form-control",
              attrs: { type: "text", id: "content3" },
            }),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("Delivery Date:\n            "),
            _c("input", {
              staticClass: "form-control",
              attrs: { type: "text", id: "content4" },
            }),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("Goods Price:\n            "),
            _c("input", {
              staticClass: "form-control",
              attrs: { type: "text", id: "content5" },
            }),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("Point of Delivery:\n            "),
            _c("input", {
              staticClass: "form-control",
              attrs: { type: "text", id: "content6" },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "All terms and conditions (including the definitions) of the Master Agreement shall apply to this Written Offer."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "IN WITNESS WHEREOF, the Customer has executed and delivered this Written Offer as of the date mentioned here in above."
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("span", [_vm._v("Yours faithfully,")]),
        _c("br"),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("span", [
          _vm._v("__________Customer Signature_____________________"),
        ]),
        _c("br"),
        _vm._v(" "),
        _c("span", [_vm._v("For and on Behalf of the Customer")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }